var $ = (jQuery = require('jquery'))
angular
  .module('surfsightApp.controllers')

  .controller('edgeQifiController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      leafletData,
      nominatimLookUp,
      $stateParams
    ) {
      $scope.qrcodeCanvas = ''
      $scope.changeInputType = false
      $scope.enc = 'WPA'
      $scope.generate = function () {
        var ssid = $scope.ssid
        var hidden = $scope.hidden
        var enc = $scope.enc
        var key = $scope.key
        if (!enc || !key) {
          return false
        }
        if (enc != 'nopass') {
          $scope.showkey = enc + ': ' + key
        } else {
          var key = ''
          $scope.showkey = ''
        }
        var qrstring =
          'WIFI:S:' +
          escape_string(ssid) +
          ';T:' +
          enc +
          ';P:' +
          escape_string(key) +
          ';'
        if (hidden) {
          qrstring += 'H:true'
        }
        qrstring += ';'
        $('#qrcode').empty()
        var qrcode_canvas = $('#qrcode').qrcode(qrstring)
        $scope.qrcodeCanvas = qrcode_canvas
        $('#qrcode').append(qrcode_canvas)
        $scope.showssid = 'SSID: ' + ssid
        $scope.$emit('qrcodeCanvasEvt', { qrcode_canvas: qrcode_canvas })
      }
      $scope.showEdgeDashcam = function () {
        $scope.$emit('showEdgeDashcam', {})
      }
      function escape_string (string) {
        var to_escape = ['\\', ';', ',', ':', '"']
        var hex_only = /^[0-9a-f]+$/i
        var output = ''
        if (string) {
          for (var i = 0; i < string.length; i++) {
            // if($.inArray(string[i], to_escape) != -1)
            if (to_escape.indexOf(string[i]) != -1) {
              output += '\\' + string[i]
            } else {
              output += string[i]
            }
          }
          return output
        }
      }
    }
  ])
